import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Row, Col, Image, Carousel } from 'react-bootstrap';
import './style/Home.css';

const homePhotos = [
  {
    name: 'photo-1',
    image: '/assets/1-foto-final.jpg',
  },
  {
    name: 'photo-2',
    image: '/assets/2-foto-final.jpg',
  },
  {
    name: 'foto-3',
    image: '/assets/3-foto-final.jpg',
  },
  {
    name: 'foto-4',
    image: '/assets/4-foto-final.jpg',
  },
  {
    name: 'foto-5',
    image: '/assets/5-foto-final.jpg',
  },
];

const Home = () => {
  return (
    <div className="home">
      <Helmet>
        <title>Studio Vinzaglio 24 - Riabilitazione Neuropsicomotoria</title>
        <meta
          name="description"
          content="Studio di riabilitazione neuropsicomotoria a Torino dal 1995. Accogliamo bambini e famiglie con interventi basati su professionalità e creatività."
        />
        <meta
          property="og:title"
          content="Studio Vinzaglio 24 | Riabilitazione Neuropsicomotoria a Torino"
        />
        <meta
          property="og:description"
          content="Dal 1995, uno spazio dedicato all'accoglienza dei bambini e delle famiglie per percorsi di cura, crescita e formazione a Torino."
        />
        <meta
          property="og:image"
          content="https://www.studiovinzaglio24.com/assets/og-logo.jpg"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.studiovinzaglio24.com/" />
        <link rel="canonical" href="https://www.studiovinzaglio24.com" />
      </Helmet>

      {/* Hero Section */}
      <section className="hero">
        <Container fluid className="hero-container">
          {/* Carousel Section */}
          <Row className="justify-content-center">
            <Col lg={8} className="text-center">
              <Carousel interval={3000} controls={true} indicators={true}>
                {homePhotos.map((photo) => (
                  <Carousel.Item>
                    <Image
                      src={photo.image}
                      alt={photo.name}
                      className="hero-image"
                      fluid
                      loading="lazy"
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </Col>
          </Row>

          {/* Text Section */}
          <Row className="justify-content-center">
            <Col lg={8} className="text-center hero-text">
              <h1>
                Studio di riabilitazione neuropsicomotoria di Corso Vinzaglio 24
              </h1>
              <p className="hero-subtext">
                <strong>
                  Dal 1995, questo spazio è dedicato ad accogliere i bambini e
                  le loro famiglie
                </strong>{' '}
                e a creare interventi in cui{' '}
                <strong> professionalità, scientificità e creatività </strong>
                si miscelano per rispondere al bisogno di cura e crescita.
              </p>

              <p className="hero-subtext">
                Affinché ciò sia possibile, consapevoli del fatto che{' '}
                <em>non si finisce mai di imparare</em>, curiamo anche la nostra
                crescita attraverso <strong>aggiornamenti </strong>
                sulle nuove conoscenze in{' '}
                <strong>ambito abi-riabilitativo</strong>, confronti con altri
                colleghi, supervisioni e percorsi di{' '}
                <strong>formazione personale</strong>.
              </p>

              <p className="hero-subtext">
                <strong>Il dialogo con la famiglia</strong> e il confronto con i
                professionisti che costituiscono la rete di ogni bambino/a e
                ragazzo/a sono parte integrante dei percorsi che proponiamo.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Home;
